export default __webpack_public_path__ + "static/media/maildoso-30x30.899a240f.svg";